"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequiredLanguages = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const useConfig_1 = require("@src/hooks/useConfig");
const react_intl_1 = require("react-intl");
const getOtherLanguagesName_1 = require("@src/helpers/getOtherLanguagesName");
const TableRow = styled_components_1.default.div `
	font-size: ${props => props.theme.fontSizes.sm};
`;
const LevelTD = styled_components_1.default.td `
	float: right;
`;
const TableWrapper = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	max-width: 300px;
`;
const LevelTitleTD = styled_components_1.default.td `
	float: right;
	color: ${props => props.theme.color.gray7};
	margin-bottom: 0.5rem;
`;
const LanguageTd = styled_components_1.default.td `
	color: ${props => props.theme.color.gray7};
	margin-bottom: 0.5rem;
`;
function checkLanguageTranslation(languageCode, config) {
    return config.languages.filter(lang => lang.code === languageCode)[0];
}
const Languages = ({ languages }) => {
    const config = (0, useConfig_1.useConfig)();
    return languages === null || languages === void 0 ? void 0 : languages.map(lang => {
        const languageTranslation = checkLanguageTranslation(lang.languageCode, config);
        return ((0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("td", { children: (0, jsx_runtime_1.jsx)(TableRow, { children: (languageTranslation === null || languageTranslation === void 0 ? void 0 : languageTranslation.value) || (0, getOtherLanguagesName_1.getOtherLanguagesName)(lang.languageCode) }) }), (0, jsx_runtime_1.jsx)(LevelTD, { children: lang.languageLevel || lang.level })] }, lang.languageCode));
    });
};
const RequiredLanguages = ({ languages }) => {
    return ((0, jsx_runtime_1.jsx)(TableWrapper, { children: (0, jsx_runtime_1.jsxs)("table", { children: [(0, jsx_runtime_1.jsx)("thead", { children: (0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsxs)(LanguageTd, { children: [(0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "offer_detail.details.language" }), ' '] }), (0, jsx_runtime_1.jsx)(LevelTitleTD, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.resume.language_level" }) })] }) }), (0, jsx_runtime_1.jsx)("tbody", { children: (0, jsx_runtime_1.jsx)(Languages, { languages: languages }) })] }) }));
};
exports.RequiredLanguages = RequiredLanguages;
